<template>
	<div class="container__fileupload">
		<input
			:id="idElement"
			ref="ref_input_file"
			class="container__fileupload__input"
			type="file"
			style="display: none"
			:accept="extensionsAccepted"
			:disabled="disabled"
			@change.prevent="onAddFile($event)"
		/>
		<div
			:class="['container__fileupload__droparea', styleFileUpload, { disabled: disabled }]"
			@dragover.stop.prevent="addDragOverStyle"
			@dragenter.stop.prevent="addDragOverStyle"
			@drop.prevent="onAddFile($event)"
		>
			<div
				ref="ref_file_mask"
				class="container__fileupload__droparea__dropmask"
				@dragleave.stop.prevent="addDragLeaveStyle"
				@dragend.stop.prevent="addDragLeaveStyle"
			/>
			<label
				class="container__fileupload__droparea__label"
				:for="idElement"
			>
				<i
					style="font-size: 1.5rem"
					:class="hasFileInBackEnd ? hasFileIcon : 'fas fa-upload'"
				/>
				{{ label }}
				<span v-if="extensionsAccepted && !hasFileInFrontEnd">({{ extensionsAccepted }})</span>
				<span v-else>{{ file.name }}</span>
			</label>
		</div>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

import { mapMutations } from 'vuex'

export default {
	props: {
		/**
		 * Habilita ou desabilita o componente para fazer upload
		 */
		disabled: {
			type: Boolean,
			default: false,
		},
		/**
		 * Retorna se o FileUpload ja possui um arquivo
		 */
		hasFileInBackEnd: {
			type: Boolean,
			default: false,
		},
		/**
		 * Se já tiver arquivo troca o icone padrão
		 */
		hasFileIcon: String,
		/**
		 * Lista com as extensões que são aceitas no upload
		 */
		extensionsAccepted: String,
		/**
		 * Label que é uma descricao que fica no elemento identificar o que significa
		 * o arquivo que deve ser enviado
		 */
		label: String,
	},
	data() {
		return {
			/**
			 * Objeto que representa o arquivo
			 */
			file: {},
			/**
			 * Se tiver arquivo sendo feito o upload
			 */
			hasFileInFrontEnd: false,
			/**
			 * Verifica se está com o arquivo em cima do componente
			 */
			isInsideDrag: false,
		}
	},
	computed: {
		/**
		 * Cria um id unico para o input
		 */
		idElement() {
			return uuidv4()
		},
		/**
		 * Define um estilo diferente para arquivos que estao sendo feito
		 * upload e para quando ja possui um arquivo que veio do backend
		 */
		styleFileUpload() {
			return {
				'has-file': this.hasFileInBackEnd && !this.isInsideDrag && !this.hasFileInFrontEnd,
				hover: this.hasFileInFrontEnd || this.isInsideDrag,
			}
		},
	},
	methods: {
		...mapMutations('moduleMessages', ['mutationShowMessage']),

		/**
		 * Método que é executado assim que arrastar um arquivo
		 */
		onAddFile(e) {
			if (!this.disabled) {
				const { dataTransfer, srcElement } = e
				const files = srcElement.files ?? dataTransfer.files

				const extension = files[0].name.split('.').pop()

				if (this.extensionsAccepted.includes(extension)) {
					this.file = files[0]
					this.hasFileInFrontEnd = true
					this.$emit('onUpload', this.file)
				} else {
					this.mutationShowMessage({
						messageTitle: this.$t('arquivoInvalido'),
						messageText: `${this.$t('formatoParaUpload')}: ${this.extensionsAccepted} `,
						messageIcon: 'fas fa-file',
						messageType: 'info',
					})
					this.hasFileInFrontEnd = false
				}
				this.$refs.ref_input_file.value = ''
			}
			this.addDragLeaveStyle()
		},
		/**
		 * Adiciona estilo no componente para mostrar que esta dentro da area do drag drop
		 */
		addDragOverStyle() {
			if (!this.disabled) {
				this.$refs.ref_file_mask.style.display = 'block'
				this.isInsideDrag = true
			}
		},
		/**
		 * Adiciona estilo no componente para mostrar que esta fora da area do drag drop
		 */
		addDragLeaveStyle() {
			if (!this.disabled) {
				this.$refs.ref_file_mask.style.display = 'none'
				this.isInsideDrag = false
			}
		},
	},
}
</script>

<style>
.container__fileupload__droparea {
	position: relative;
	outline: 1px dashed var(--color-green);
	color: rgb(var(--color-primary));
	outline-width: 1px;
	background-color: rgb(250, 250, 250);
	width: 100%;
	border-radius: 5px;
	cursor: pointer;
	transition: all 0.2s linear;
	margin: 0 !important;
}

.container__fileupload__droparea.disabled {
	opacity: 0.6;
}

.container__fileupload__droparea.hover {
	background-color: rgb(var(--color-primary));
	color: rgb(var(--color-default));
	outline: 1px dashed rgb(var(--color-default));
	outline-offset: -10px;
}

.container__fileupload__droparea.has-file {
	background-color: rgb(var(--color-default));
	color: white;

	outline: 1px solid rgb(var(--color-default));
}

.container__fileupload__droparea__dropmask {
	display: none;
	position: absolute;
	width: 100%;
	height: 100%;
	z-index: 99;
	left: 0;
	top: 0;
}

.container__fileupload__input:disabled + .container__fileupload__droparea,
.container__fileupload__input:disabled
	+ .container__fileupload__droparea
	.container__fileupload__droparea__label {
	color: gray;
	cursor: no-drop;
}

.container__fileupload__droparea__label {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	font-size: 0.75rem;
	cursor: pointer;
	padding: 0.5rem;
}

.container__fileupload__droparea__label i {
	font-size: 2rem;
}
</style>
